// One closed trade, read from Hyperliquid fills.
// On each fill, Hyperliquid's Closed PNL column is `closedPnl - fee`:
// the open line is the opening fee, the close line is the price result
// minus the closing fee. The trade is those lines added together.

export function timeMs(value) {
  if (!value) return 0;
  if (typeof value.toDate === 'function') return value.toDate().getTime();
  if (typeof value === 'number') return value;
  const n = new Date(value).getTime();
  return Number.isFinite(n) ? n : 0;
}

export function tradeResult(signal, fills, nextMs = null) {
  if (!signal || signal.status === 'duplicate_skipped') return null;

  const coin = (signal.symbol || '').replace(/USDT$/, '').replace(/PERP$/, '');
  const direction = (signal.direction || '').toUpperCase();
  const side = direction === 'SHORT' ? 'Short' : 'Long';
  const start = timeMs(signal.timestamp);
  const exit = timeMs(signal.exit_time);
  const closed = exit || signal.exit_price != null || signal.exit_reason;
  if (!coin || !start || !closed) return null;

  const list = Array.isArray(fills) ? fills : [];
  const sameSide = f => f.coin === coin && (f.dir || '').includes(side);

  // The open is filled within seconds of the signal. A later same-side open
  // belongs to the next trade.
  const openFills = list.filter(f =>
    sameSide(f) &&
    (f.dir || '').includes('Open') &&
    f.time >= start - 5_000 &&
    f.time <= start + 20_000
  );

  // The close fill lands just after the opposite signal is saved, so the
  // window has to extend past that timestamp. It stops before the next
  // same-side trade.
  const closeEnd = (nextMs || exit || start) + 15_000;
  const closeFills = list.filter(f =>
    sameSide(f) &&
    (f.dir || '').includes('Close') &&
    f.time >= start &&
    f.time <= closeEnd
  );
  if (closeFills.length === 0) return null;

  const related = [...openFills, ...closeFills];
  const fees = related.reduce((sum, f) => sum + (parseFloat(f.fee) || 0), 0);
  const net = related.reduce(
    (sum, f) => sum + (parseFloat(f.closedPnl) || 0) - (parseFloat(f.fee) || 0),
    0,
  );
  return { net, fees };
}
